import { render } from "./wButtonAdd.vue?vue&type=template&id=5df9908c&ts=true"
import script from "./wButtonAdd.vue?vue&type=script&lang=ts"
export * from "./wButtonAdd.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__